import React from 'react';

const Grok4Launch = () => (
  <article className="news-article-body">
    <p className="news-lead">
      Grok 3 arrived in February 2025, quietly topping several key benchmarks. By mid-2025,
      Grok 4 had followed - a more capable reasoning model that Elon Musk claimed could
      pass the Turing Test and score near the top of global mathematical olympiad rankings.
      Whether you believe all the claims or not, Grok's trajectory from quirky Twitter
      chatbot to legitimate frontier competitor has been surprisingly fast.
    </p>

    <h2>Grok 3 - what it got right</h2>
    <p>
      Released February 17, 2025, Grok 3 was trained on xAI's Colossus cluster - at the
      time the largest AI training cluster ever built, with 100,000 NVIDIA H100 GPUs.
      That raw training compute translated into real benchmark results:
    </p>
    <ul>
      <li>AIME (maths competition): 93.3% - above GPT-4o and Claude 3.5</li>
      <li>GPQA Diamond (graduate science): 84.6%</li>
      <li>LiveCodeBench (real-world coding): 79.4%</li>
    </ul>
    <p>
      The "Think" mode was especially well-received - it slows down to work through hard
      problems step-by-step, similar to how OpenAI's o1 operates. For complex maths and
      coding tasks, it made a noticeable difference.
    </p>

    <h2>Grok 4 - the next step</h2>
    <p>
      Grok 4 launched in mid-2025 as xAI's most capable model. Key additions over Grok 3:
    </p>
    <ul>
      <li><strong>Voice mode:</strong> Real-time voice conversations with lower latency</li>
      <li><strong>Aurora image generation:</strong> High-quality text-to-image built in</li>
      <li><strong>DeepSearch:</strong> Live web browsing combined with reasoning chains</li>
      <li><strong>Autonomous agent mode:</strong> Can browse the web, write and run code,
          and complete multi-step tasks without constant prompting</li>
    </ul>
    <p>
      Musk positioned Grok 4 as "the most intelligent AI in the world" at launch - a
      claim that's always contested the moment you say it, but one backed by some
      impressive olympiad-level maths results.
    </p>

    <h2>The xAI advantage (and the controversy)</h2>
    <p>
      xAI has a genuine advantage competitors don't: real-time X (Twitter) data. Grok
      can reference live posts, trending topics, and breaking news in its responses.
      For someone asking about current events, market sentiment, or social trends,
      that's actually useful.
    </p>
    <p>
      But xAI doesn't get a free pass. Grok has generated controversy for refusing to
      add safety guardrails on politically sensitive content - by design. Musk has
      explicitly positioned it as an "anti-woke" alternative. Whether that's a
      feature or a problem depends heavily on who you ask.
    </p>

    <h2>What's next: Colossus expansion</h2>
    <p>
      xAI is reportedly scaling Colossus to one million GPUs. If that happens, Grok's
      training runs will dwarf what any other lab is doing today. The question is
      whether raw scale keeps delivering proportional gains - something the field
      increasingly debates.
    </p>

    <div className="news-insight-box">
      <h3>The big lesson</h3>
      <p>
        xAI went from founding (2023) to top-tier frontier competitor in under two years.
        The Colossus cluster investment was the key move - more compute, faster iteration,
        better models. The real test is whether Grok's unique real-time X data advantage
        translates into lasting user value, or whether it's just a differentiator on paper.
      </p>
    </div>
  </article>
);

export default Grok4Launch;
